export default "<div class=\"row\">\r\n  <div class=\"col-md-12 col-sm-12\">\r\n    <app-unity-list></app-unity-list>\r\n  </div>\r\n</div>\r\n"